import {API_URLS} from '@/const/urls';
import {http} from '@/helper/http';

export const referralApi = {
  getReferralLink(query) {
    return http.get(API_URLS.REFERRAL_LINK_PAGE, {query});
  },
  getReferralReward(query) {
    return http.get(API_URLS.REFERRAL_REWARD_PAGE, {query});
  },
  getReferralRewardSummary(query) {
    return http.get(API_URLS.REFERRAL_REWARD_SUMMARY, {query});
  },
  getReferralConfig(query) {
    return http.get(API_URLS.REFERRAL_CONFIG, {query});
  },
  getReferralEarning(query) {
    return http.get(API_URLS.REFERRAL_EARNING, {query});
  },
  getReferralHistory(query) {
    return http.get(API_URLS.REFERRAL_HISTORY, {query});
  },
  // 被邀请人页面按钮状态
  getKycStatus(query) {
    return http.get(API_URLS.REFERRAL_KYC, {query});
  },
  getDepositStatus(query) {
    return http.get(API_URLS.REFERRAL_DEPOSIT_STATUS, {query});
  },
};
